<div class="support-admin-page">
  <h2 class="support-admin-page-title">{{ 'support.manage.pageTitle' | transloco }}</h2>
  @if (access.canManage()) {
    @if (list(); as listComponent) {
      <ng-container *ngComponentOutlet="listComponent" />
    } @else if (loadFailed()) {
      <p class="support-admin-page-error" role="alert" data-test-id="support-page-load-failed">{{ 'support.manage.loadFailed' | transloco }}</p>
    } @else {
      <div class="support-admin-page-loading" role="status" aria-busy="true" data-test-id="support-page-loading"></div>
    }
  } @else {
    <p class="support-admin-page-no-access" data-test-id="support-no-access">{{ 'support.manage.noAccess' | transloco }}</p>
  }
</div>
